import _get from 'lodash/get';
import React from 'react';
import ReactHighcharts from 'react-highcharts';
import intl from 'react-intl-universal';
import { DWHCallDataResultType, DWHResponse } from '../../../interfaces/Dashboard';
import { sortCallDataByDateAsc } from '../../../utils/callDataUtils';
import { generateCallChartConfig } from '../../../utils/highChartsConfigs';
import { DashboardLoader } from '../DashboardLoader';
import * as styles from './Charts.scss';
import { DashboardNoResults } from '../DashboardNoResults';
import { dataWarehouseSelectors } from '@lifesize/nucleus';
import { connect } from 'react-redux';
import { Global } from '../../../state/Global';

interface Props {
  callDataByDaysDevice: DWHResponse;
}

const getConfigForChart = (callDataByDays: DWHResponse, title: string, yAxisTitle: string) => {
  let config = null;
  const data = _get(callDataByDays, 'data.data', null) as Array<DWHCallDataResultType> | null;
  if (data) {

    const sortedData = sortCallDataByDateAsc(data);
    const categories = sortedData.map((result) => {
      // @ts-ignore
      return result.period;
    });
    const series = sortedData.map((result) => {
      return result.totalMinutes;
    });
    config = generateCallChartConfig(categories, series, '#8877a9', title, yAxisTitle);
  }
  return config;
};

export const CallMinutesPerDay = ({ callDataByDaysDevice }: Props) => {
  const divId = 'callMinutesPerDay';
  if (callDataByDaysDevice && callDataByDaysDevice.isFetching) {
    return (
      <DashboardLoader divId={divId} title={intl.get('minutesPerDay')}/>
    );
  }

  const config =
    getConfigForChart(callDataByDaysDevice, intl.get('minutesPerDay'), intl.get('minutes'));
  if (config) {
    return (
      <div className={styles.container} id={divId}>
        <ReactHighcharts
          isPureConfig={true}
          neverReflow={true}
          config={config}
        />
      </div>
    );
  }

  return (
    <DashboardNoResults divId={divId} title={intl.get('minutesPerDay')}/>
  );
};

export default CallMinutesPerDay;

function mapStateToProps(state: Global) {
  return {
    callDataByDaysDevice: dataWarehouseSelectors.callsByDaysDevicesSelector(state),
  };
}

const mapDispatchToProps = (dispatch: Function) => ({});

export const CallMinutesPerDayContainer = connect(mapStateToProps, mapDispatchToProps)(CallMinutesPerDay);
